import { TWatchesCommandsTypes } from 'types';
import { ICreateWatchesData, TTypeOfModalWindow, IWatchesRanges } from './watchesContext';

export enum WatchesActionsTypes {
	SET_WATCHES_QUANTITY = 'SET_WATCHES_QUANTITY',
	SET_ADMIN_WATCHES_QUANTITY = 'SET_ADMIN_WATCHES_QUANTITY',
	SET_COMMANDS = 'SET_COMMANDS',
	CHANGE_WATCHES_TABLE_RANGES = 'CHANGE_WATCHES_TABLE_RANGES',
	CHANGE_ADMIN_WATCHES_TABLE_RANGES = 'CHANGE_ADMIN_WATCHES_TABLE_RANGES',
	SET_DATA_FOR_SUBMIT = 'SET_DATA_FOR_SUBMIT',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
}

interface ISetWatchesQuantity {
	type: WatchesActionsTypes.SET_WATCHES_QUANTITY;
	payload: {
		watchesQuantity: null | number;
		watchesTableRanges: IWatchesRanges[];
	};
}

interface ISetAdminWatchesQuantity {
	type: WatchesActionsTypes.SET_ADMIN_WATCHES_QUANTITY;
	payload: {
		adminWatchesQuantity: null | number;
		adminWatchesTableRanges: IWatchesRanges[];
	};
}

interface ISetCommands {
	type: WatchesActionsTypes.SET_COMMANDS;
	payload: {
		commands: TWatchesCommandsTypes[];
	};
}

interface IChangeWatchesTableRanges {
	type: WatchesActionsTypes.CHANGE_WATCHES_TABLE_RANGES;
	payload: {
		watchesTableRanges: IWatchesRanges[];
	};
}

interface IChangeAdminWatchesTableRanges {
	type: WatchesActionsTypes.CHANGE_ADMIN_WATCHES_TABLE_RANGES;
	payload: {
		adminWatchesTableRanges: IWatchesRanges[];
	};
}

interface ISetDataForSubmit {
	type: WatchesActionsTypes.SET_DATA_FOR_SUBMIT;
	payload: {
		dataForSubmit: ICreateWatchesData | null;
	};
}

interface IChangeTypeOfModalWindow {
	type: WatchesActionsTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: TTypeOfModalWindow;
	};
}

export type TWatchesAction =
	| ISetWatchesQuantity
	| ISetAdminWatchesQuantity
	| ISetCommands
	| IChangeWatchesTableRanges
	| IChangeAdminWatchesTableRanges
	| ISetDataForSubmit
	| IChangeTypeOfModalWindow;
